import { h, JSX } from "preact"

const Error = (props: { children: JSX.Element | string }) => (
  <div className="flex flex-row items-center justify-center text-xl text-red-500">
    {props.children}
  </div>
)

export default Error
